import { Navigate, useNavigate } from "react-router-dom";

// 2. PaySlip.jsx
const PaySlip = () => {
    const navigate = useNavigate();
  return (
    <div className="p-4 min-h-screen bg-white">
      <div className="flex items-center gap-4 mb-4">
        <button>&larr;</button>
        <h1 className="text-lg font-bold">John DoE</h1>
      </div>

      <div className="grid grid-cols-2 gap-4 mb-4">
        <input type="date" className="border p-2 rounded" placeholder="Start Date" />
        <input type="date" className="border p-2 rounded" placeholder="End Date" />
      </div>

      <div className="bg-primary text-red-800 p-4 rounded mb-4 font-semibold text-xl flex justify-between">
        <span>$0.00</span>
        <button className="bg-primary text-white px-3 py-1 rounded">+ Add Salary</button>
      </div>

      {[...Array(5)].map((_, index) => (
        <div key={index} className="flex justify-between items-center bg-gray-50 p-3 rounded mb-2">
          <p className="text-sm">28 Dec 2024</p>
          <span className="text-xs px-3 py-1 bg-green-500 text-white rounded-full">Present</span>
          <span className="text-sm bg-primary text-primary px-3 py-1 rounded">0.0</span>
        </div>
      ))}

      <div className="text-right text-sm mt-6">Base Salary (3 Days): $0.00</div>
      <div className="flex justify-between text-sm mt-2">
        <span className="bg-green-100 text-green-600 px-3 py-1 rounded">+ Additions</span>
        <span className="bg-primary text-primary px-3 py-1 rounded">- Deductions</span>
        <span>Total <strong>$0.00</strong></span>
      </div>

      <button className="w-full bg-primary text-white py-3 mt-6 rounded"  onClick={() => navigate(`/payroll-preview`)}>Generate Salary Slip</button>
    </div>
  );
};

export default PaySlip;
